export default __webpack_public_path__ + "97dcee6dea35dd7e3003892b50035c88.ttf";